export const authentication = {
    activeChangePasswordStrategy: true,
    displayGARHelper: false,
    displayLoginLogo: true,
    enableFormLogin: true,
    enableGAR: true,
    enableSSO: false,
    firstConnexionRedirection: {
        trainer: '/groups/list/groups'
    },
    overrideDefaultRouteByRole: {
        learner: '/home',
        trainer: '/home',
    },
    licenceLink: '',// lien vers formulaire licence
    showEdito: true, // show edito on firs connexion in regard of ent (uea)
};
